"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var Settings_1 = __importDefault(require("@material-ui/icons/Settings"));
var formik_1 = require("formik");
var formik_material_ui_lab_1 = require("formik-material-ui-lab");
var react_intl_1 = require("react-intl");
var formik_material_ui_1 = require("formik-material-ui");
var Yup = __importStar(require("yup"));
var useStyles = core_1.makeStyles({
    errorText: {
        color: '#f44336',
    },
});
function TTableSettingsPreset(props) {
    var _this = this;
    var classes = useStyles();
    var intl = react_intl_1.useIntl();
    var fetchUserRoleList = props.fetchUserRoleList, saveListPresets = props.saveListPresets, presets = props.presets, loadPresets = props.loadPresets, isLoading = props.isLoading;
    var _a = react_1.useState(false), open = _a[0], setOpen = _a[1];
    var _b = react_1.useState(), userRoleList = _b[0], setUserRoleList = _b[1];
    react_1.useEffect(function () {
        var getData = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchUserRoleList()];
                    case 1:
                        response = _a.sent();
                        setUserRoleList(response);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
    }, []);
    var initialValues = react_1.useMemo(function () {
        return presets.filter(function (preset) { return preset.id !== 'default' && !preset.autoSaved; });
    }, [presets]);
    var onSubmit = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var listPresetsForSave;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    listPresetsForSave = values.map(function (value) {
                        return value.shared ? __assign(__assign({}, value), { sharedRules: value.sharedRules }) : __assign(__assign({}, value), { sharedRules: [] });
                    });
                    return [4 /*yield*/, saveListPresets(listPresetsForSave)];
                case 1:
                    _a.sent();
                    loadPresets();
                    setOpen(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var schema = react_1.useMemo(function () {
        return Yup.array().of(Yup.object()
            .shape({})
            .test('notUniqueSharedRule', function () {
            return __awaiter(this, void 0, void 0, function () {
                var isOverlap, currentElementIndex;
                var _this = this;
                return __generator(this, function (_a) {
                    isOverlap = false;
                    currentElementIndex = Number(this.path.slice(1, -1));
                    this.parent.forEach(function (item, index) {
                        if (item.default &&
                            _this.parent[currentElementIndex].default &&
                            index !== currentElementIndex &&
                            Boolean(_this.parent[currentElementIndex].sharedRules.filter(function (sharedRule) {
                                return item.sharedRules.includes(sharedRule);
                            }).length)) {
                            isOverlap = true;
                        }
                    });
                    return [2 /*return*/, isOverlap
                            ? this.createError({
                                path: this.path + ".sharedRules",
                                message: intl.formatMessage({
                                    id: 'ttable.notUniqueSharedRule',
                                    defaultMessage: 'Правила доступности не должны пересекаться: роль пользователя может быть указана только в одном пресете по умолчанию',
                                }),
                            })
                            : true];
                });
            });
        }));
    }, [Yup, intl]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.IconButton, { onClick: function () {
                !isLoading && setOpen(true);
            } },
            react_1.default.createElement(Settings_1.default, null)),
        react_1.default.createElement(core_1.Dialog, { open: open, fullWidth: true, maxWidth: "md" },
            react_1.default.createElement(core_1.DialogTitle, null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.presetManagement", defaultMessage: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u0435\u0441\u0435\u0442\u0430\u043C\u0438" })),
            react_1.default.createElement(formik_1.Formik, { validationSchema: schema, initialValues: initialValues, onSubmit: function (values) { return onSubmit(values); } }, function (_a) {
                var values = _a.values, errors = _a.errors, submitCount = _a.submitCount;
                return (react_1.default.createElement(formik_1.Form, null,
                    react_1.default.createElement(core_1.DialogContent, null,
                        react_1.default.createElement(core_1.TableContainer, { component: core_1.Paper },
                            react_1.default.createElement(core_1.Table, { size: "small" },
                                react_1.default.createElement(core_1.TableHead, null,
                                    react_1.default.createElement(core_1.TableRow, null,
                                        react_1.default.createElement(core_1.TableCell, null,
                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.preset", defaultMessage: "\u041F\u0440\u0435\u0441\u0435\u0442" })),
                                        react_1.default.createElement(core_1.TableCell, { align: "center" },
                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.common", defaultMessage: "\u041E\u0431\u0449\u0438\u0439" })),
                                        react_1.default.createElement(core_1.TableCell, { align: "center" },
                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.default", defaultMessage: "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E" })),
                                        react_1.default.createElement(core_1.TableCell, null,
                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.accessibilityRule", defaultMessage: "\u041F\u0440\u0430\u0432\u0438\u043B\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442\u0438" })))),
                                react_1.default.createElement(core_1.TableBody, null, initialValues.map(function (row, index) { return (react_1.default.createElement(core_1.TableRow, { key: index + ".title" },
                                    react_1.default.createElement(core_1.TableCell, null, row.title),
                                    react_1.default.createElement(core_1.TableCell, { align: "center" },
                                        react_1.default.createElement(formik_1.Field, { type: "checkbox", component: formik_material_ui_1.Checkbox, name: index + ".shared", color: "primary" })),
                                    react_1.default.createElement(core_1.TableCell, { align: "center" }, values[index].shared && (react_1.default.createElement(formik_1.Field, { type: "checkbox", component: formik_material_ui_1.Checkbox, name: index + ".default", color: "primary" }))),
                                    react_1.default.createElement(core_1.TableCell, null, values[index].shared && (react_1.default.createElement(formik_1.Field, { name: index + ".sharedRules", multiple: true, component: formik_material_ui_lab_1.Autocomplete, options: userRoleList === null || userRoleList === void 0 ? void 0 : userRoleList.map(function (role) { return role.code; }), getOptionLabel: function (option) { return userRoleList === null || userRoleList === void 0 ? void 0 : userRoleList.filter(function (role) { return role.code === option; })[0].title; }, style: { width: 300 }, size: "small", renderInput: function (params) {
                                            var _a, _b;
                                            return (react_1.default.createElement(core_1.TextField, __assign({}, params, { name: index + ".sharedRules", placeholder: Boolean(values[index].sharedRules.length)
                                                    ? undefined
                                                    : intl.formatMessage({
                                                        id: 'ttable.all',
                                                    }), error: !!((_a = errors[index]) === null || _a === void 0 ? void 0 : _a.sharedRules), helperText: (_b = errors[index]) === null || _b === void 0 ? void 0 : _b.sharedRules, variant: "outlined" })));
                                        } }))))); })))),
                        Boolean(submitCount) && (react_1.default.createElement("div", { className: classes.errorText }, errors.minOneDefault))),
                    react_1.default.createElement(core_1.DialogActions, null,
                        react_1.default.createElement(core_1.Button, { type: "submit", variant: "contained", color: "primary" },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.save", defaultMessage: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" })),
                        react_1.default.createElement(core_1.Button, { variant: "contained", onClick: function () { return setOpen(false); } },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.cancel", defaultMessage: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" })))));
            }))));
}
exports.default = TTableSettingsPreset;
